module.exports = {"540528100":"加查镇","540528101":"安绕镇","540528200":"拉绥乡","540528201":"崔久乡","540528202":"坝乡","540528203":"冷达乡","540528204":"洛林乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540528.json
// module id = 2535
// module chunks = 0